import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import qs from "qs";
import type { ProvidersList } from "@reactive-resume/dto";

const updateProvider = async (id: string, name: string) => {
  const response = await axios.put(`/provider/${id}`, { name });
  return response.data;
};

export const useUpdateProvider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, name }: { id: string; name: string }) => updateProvider(id, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};
